<script lang="ts">
  import { pop } from "svelte-spa-router";
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import type { Agreement, Terms } from "../../../apis/parkito";
  import { Toast } from "$components";
  import { withApi } from "$shared/lib/api-parkito";
  import LoadingIndicator from "$shared/components/LoadingIndicator.svelte";
  import SvelteMarkdown from "svelte-markdown";

  // Exported variable with name `params` is set
  // by svelte-spa-router. Check App.svelte
  export let params: { id: string };

  let isLoading = true;
  let agreement: Agreement | undefined = undefined;
  let terms: Terms[] = [];

  onMount(() => {
    if (import.meta.env.DEV) console.log("Agreement terms");
    getAgreement();
  });

  const getAgreement = async () => {
    isLoading = true;
    const res = await withApi((api) => {
      return api.getAgreement(params.id);
    });

    if (res.isOk()) {
      agreement = res.value;
    } else {
      Toast.error("Kunde inte hämta avtal");
    }
    isLoading = false;
  };

  const getTerms = async (agreementId: string) => {
    isLoading = true;
    const res = await withApi((api) => {
      return api.getAgreementFullTerms(agreementId);
    });
    isLoading = false;

    if (res.isOk() && res.value) {
      terms = res.value;
    } else {
      Toast.error("Kunde inte hämta villkor");
    }
  };

  $: {
    if (agreement) {
      getTerms(agreement.id);
    }
  }
</script>

<div>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <button
      on:click={() => {
        pop();
      }}
      class="-ml-[8px]"
    >
      <img
        src="./icons/arrow-left-small.svg"
        class="w-[24px] inline p-[8px] pb-[11px]"
        alt="arrow-left"
      />
    </button>
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Villkor för {agreement?.number ?? "-"}
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  {#if isLoading}
    <LoadingIndicator visible={true} customClass={"my-[48px]"} />
  {:else}
    <div
      class="w-full markdown min-[840px]:columns-2 columns-1 p-[24px] max-mobile:px-[8px]"
    >
      {#each terms as termPart}
        <div class="mb-[16px]">
          <SvelteMarkdown options={{}} source={termPart.content} />
        </div>
      {/each}
    </div>
  {/if}
</div>
